const state = {
  component: "vpd-registration-panel",
};

export default state;
